'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BodyClass = function (_React$Component) {
  (0, _inherits3.default)(BodyClass, _React$Component);

  function BodyClass() {
    (0, _classCallCheck3.default)(this, BodyClass);
    return (0, _possibleConstructorReturn3.default)(this, (BodyClass.__proto__ || (0, _getPrototypeOf2.default)(BodyClass)).apply(this, arguments));
  }

  (0, _createClass3.default)(BodyClass, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      addOrRemoveClassNames(this.props.classNames, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      addOrRemoveClassNames(this.props.classNames);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return BodyClass;
}(React.Component);

/**
 * Add or remove classes to the body element's classList.
 *
 * @param  {String|Array} classNames - Class or classes to add or remove.
 * @param  {Boolean} add - If true, adds classNames. Otherwise, removes them.
 */


BodyClass.defaultProps = {
  children: null
};
function addOrRemoveClassNames(classNames, add) {
  if (document && document.body) {
    var body = document.body;

    if (typeof classNames === 'string') {
      classNames = classNames.split(' ');
    }

    classNames.forEach(function (className) {
      if (add) {
        body.classList.add(className);
      } else {
        body.classList.remove(className);
      }
    });
  }
}

exports.default = BodyClass;